import * as Constants from '../../constants';

export function validateReqBodyFn(data) {
    let userData = JSON.parse(localStorage.getItem(Constants.USER_DATA));

    data["login_user_id"] = userData.login_user_id

    return data
}

export function requestHeadersKeyValues() {
    let userData = JSON.parse(localStorage.getItem(Constants.USER_DATA));

    return { "Authorization": `Bearer ${userData.token}`, "Session-id": userData.session_id }
}